import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { ExtractFromLoadService } from '../extract-from-load.service';
import { ConfigPopupComponent } from '../config-popup/config-popup.component';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';

@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.scss']
})
export class SubmitComponent implements OnInit {
  instanceList: any;
  selectedInstance: any;
  checked: boolean = true;
  public rtrplus: boolean = false;
  public ptpplus: boolean = false;
  public otcplus: boolean = false;
  public ppmplus: boolean = false;
  batchKeyDetails: any;
  public ptmplus: boolean = false;
  public itemNumber = 1;
  public progressBarName = 'submit';
  public progressBarArray1 = [
    { name: "select", src: 'assets/complete.png', index: 0 },
    { name: "submit", src: 'assets/submit.png', index: 1 },
    { name: "parameters", src: 'assets/params.svg', index: 2 },
  { name: "extract", src: 'assets/extract.png', index: 3 }
  ];
  public batchKey: string;
  public projectId: string;
  public projectName: string;
  public options: any;
  public tracks = [];
  public configData = [];
  public showArray = [];
  fromTable: any;
  submitBtnEnable: boolean;
  constructor(
    public dialog: MatDialog, private celService: ExtractFromLoadService,
    private router: Router, private route: ActivatedRoute, private _data: DataService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {
    if (this.celService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      this.fromTable = this.celService.fromTable;
      this.instanceList = this.celService.instanceList;
      this.selectedInstance = this.celService.instanceName;
      this.batchKeyDetails = this.celService.batchKeyDetails;
      this.batchKey = this.celService.batchKey;
      this.projectId = this.celService.projId;
      if (this.fromTable) {
        this.tracks = this.celService.tracksFromTable;
        this.submitBtnEnable = this.getLineItemsEdit(this.batchKeyDetails).length > 0 ? true : false;
      } else {
        this.tracks = this.celService.configObj?.tracks;
        this.configData = this.celService.configObj?.configData;
        this.submitBtnEnable = this.getLineItems(this.configData).length > 0 ? true : false;
      }
      this.setShowArray();
    }
  }

  setShowArray() {
    this.tracks.forEach((val, index) => {
      this.showArray[index] = false;
    });
  }

  onInstanceChange(instance) { }

  configPopUp(evt, data) {
    evt.stopPropagation();
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.celService.instanceName = this.selectedInstance;
      this.celService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigData(result, this.configData);
        this.celService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
        this.submitBtnEnable = this.getLineItems(this.configData).length > 0 ? true : false;
      } else {
        this.celService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
      }
    });
  }

  configPopUpEdit(evt, data) {
    evt.stopPropagation();
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.celService.instanceName = this.selectedInstance;
      this.celService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigDataEdit(result, this.batchKeyDetails);
        this.celService.tracksFromTable = this.tracks;
        this.celService.batchKeyDetails = this.batchKeyDetails;
        this.submitBtnEnable = this.getLineItemsEdit(this.batchKeyDetails).length > 0 ? true : false;
      } else {
        this.celService.tracksFromTable = this.tracks;
        this.celService.batchKeyDetails = this.batchKeyDetails;
      }
    });
  }

  setSelectedconfigData(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (selConfigData.TRACK == element.TRACK && selConfigData.APPLICATION == element.APPLICATION && selConfigData.APPLICATION_SHORT_CODE == element.APPLICATION_SHORT_CODE) {
        this.configData.splice(index, 1, selConfigData);
      }
    });
  }

  setSelectedconfigDataEdit(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (selConfigData.track == element.track && selConfigData.application == element.application && selConfigData.applicationshortcode == element.applicationshortcode) {
        this.batchKeyDetails.splice(index, 1, selConfigData);
      }
    });
  }

  onSubmitAfterReport() {
    this.maskPage();
    const body = this.onConfigSubmit();
    this.celService.instanceName = this.selectedInstance;
    this.celService.onConfigSubmit(body).subscribe((res) => {
      this.unMaskPage();
      this.batchKey = res.Batch_Key;
      this.celService.batchKey = this.batchKey;
      if (res.Batch_Key) {
        const dialogRef = this.dialog.open(InfoPopupComponent, {
          width: "917px",
          height: (this.celService.getReportStatus) ? "220px" :"280px",
          data: {
            type: 'Task Status',
            mess: (this.celService.getReportStatus) ? `Batch Key ${res.Batch_Key} <b>: New</b>` : "",
            cloudExtract: true,
            reportStatus: this.celService.getReportStatus
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result === "ok" || result === "") {
            this.maskPage();
            this.celService.getBatchKeyDetails(this.batchKey).subscribe(res => {
              if(!this.fromTable){
                this.celService.batchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
              }else{
                this.celService.UpdatedbatchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
              }              
              console.log("this.celService.batchKeyDetails",this.celService.batchKeyDetails);
              this.unMaskPage();
              this.celService.tabval.next("extract");
              this.router.navigate(["../extract"], { relativeTo: this.route });
            }, err => {
              this.unMaskPage();
              this.notification.showError('Something went wrong!');
            });
          } else if (result === "params"){
            this.maskPage();
            this.celService.getBatchKeyDetails(this.batchKey).subscribe(res => {
              if(!this.fromTable){
                this.celService.batchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
              }else{
                this.celService.UpdatedbatchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
              }  
              console.log("this.celService.batchKeyDetails",this.celService.batchKeyDetails);
              this.unMaskPage();
              this.celService.tabval.next("parameters");
              this.router.navigate(["../params"], { relativeTo: this.route });
            }, err => {
              this.unMaskPage();
              this.notification.showError('Something went wrong!');
            });
          }
        });
      } else {
        alert(res.Result);
      }
    },
      (error) => {
        this.unMaskPage();
        this.notification.showError('Something went wrong!');
      });
  }


  getReport(id){
    this.celService.getReportStatus = false;
    this.celService.getReport(id).subscribe((res) => { 
      if(res.Result === "SUCCESS"){
        this.celService.getReportStatus = true;
      }
      else{
        this.celService.getReportStatus = false;
      }
      this.onSubmitAfterReport();
    }, error => {
      this.celService.getReportStatus = false;
      this.onSubmitAfterReport();
    });
  }

  onSubmit() {
    this.maskPage();
    // this.celService.getReportStatus = true;
    // this.onSubmitAfterReport();
    this.getReport(this.selectedInstance.INSTANCE.toString());
  }


  onConfigSubmit() {
    let body;
    if (this.fromTable) {
      body = {
        batchkey: this.batchKeyDetails[0].batchkey,
        projectname: this.batchKeyDetails[0].projectname,
        // projectname: 'TestProj1',
        requestedby: this.batchKeyDetails[0].requestedby,
        filesharepath: this.batchKeyDetails[0].filesharepath,
        requesttype: DconConfigAPI.API_VARIABLES.Request_Type_Extract,//"EXTRACT",
        extracttype: DconConfigAPI.API_VARIABLES.Extract_Type_SQL,//"SQL",
        instanceid: this.selectedInstance.INSTANCE_ID.toString(),
        LineItems: this.getLineItemsEdit(this.batchKeyDetails)
      };
    } else {
      body = {
        batchkey: this.celService.batchKey ? this.celService.batchKey : "",
        projectname: this.projectId,
        requestedby: this.celService.requestedBy,
        filesharepath: this.celService.getfileSharePath(),//"\\\\usazuconde00173\\DFTE\\",
        requesttype: DconConfigAPI.API_VARIABLES.Request_Type_Extract,//"EXTRACT",
        extracttype: DconConfigAPI.API_VARIABLES.Extract_Type_SQL,//"SQL",
        instanceid: this.selectedInstance.INSTANCE_ID.toString(),
        LineItems: this.getLineItems(this.configData)
      };
    }

    return body;
  }

  getLineItems(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.TASK != null && element.saveStatus) {
        element.TASK.forEach((ele) => {
          if (ele.selectStatus === "y") {
            const trackObj = {
              track: element.TRACK,
              applicationshortcode: element.APPLICATION_SHORT_CODE,
              taskname: ele.TASK_NAME,
              taskcode: ele.TASK_CODE
            };
            data.push(trackObj);
          }
        });
      }
    });
    return data;
  }

  getLineItemsEdit(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.linedetail != null && element.linedetail?.length > 0) {
        element.linedetail.forEach((ele) => {
          if (ele.taskselected === "Y") {
            const trackObj = {
              track: element.track,
              applicationshortcode: element.applicationshortcode,
              taskname: ele.taskname,
              taskcode: ele.taskcode
            };
            data.push(trackObj);
          }
        });
      }
    });
    return data;
  }

  prepareObjSet(batchDetails) {
    const data = [];
    batchDetails.forEach(element => {
      const obj = JSON.parse(element.config_details);
      obj['saveStatus'] = false;
      if (obj.linedetail != null && obj.linedetail.length > 0) {
        obj.linedetail.forEach(elem => {
          if (elem.taskselected === 'Y') {
            obj['saveStatus'] = true;
          }
        });
      }
      data.push(obj);
    });
    return data;
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  unMaskPage() {
    this._data.apiCallInProgress = false;
    document.getElementById("overlay").style.display = "none";
  }


  // addParams(){
  //   this.router.navigate(["../params"], { relativeTo: this.route });
  // }
}
